import { Container, injectable } from 'inversify'
import 'reflect-metadata'
import { IDobleAuthenticationUserRepository } from '../domain/IDobleAuthenticationUserRepository';
import { computed, watch } from 'vue';
import MyApolloClient from '../../../../common/infrastructure/funciones/HelperApolloClient';
import { CONFIRM_DOBLE_FACTOR_USER, GET_DOBLE_FACTOR_USER_TYPES, SET_DOBLE_FACTOR_USER_CODE } from './query/dobleAuthenticationUserQuery';
import { UsuarioDobleAutenticacion } from '../domain/usuarioDobleAutenticacion';
import HelperUtils from '../../../../common/infrastructure/funciones/HelperUtils';

@injectable()
export class DobleAuthenticationUserApolloClientRepository implements IDobleAuthenticationUserRepository {
  private apolloClient : MyApolloClient
  constructor (apolloInstance: MyApolloClient) {
    this.apolloClient = apolloInstance
  }
  async getDobleFactorUserCode (userId: number): (Promise<UsuarioDobleAutenticacion>) {
    return new Promise<UsuarioDobleAutenticacion>(async (resolve, reject) => {
      const result = this.apolloClient.executeQuery(GET_DOBLE_FACTOR_USER_TYPES, { userId: userId })
      
      watch(result, (value: any) => {
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.usuarioDobleAutenticacionQuery.getDobleFactorUserCode[0].codigo)
        }
        catch(e) {
          reject()
        }
      });
    });
  }

  async setDobleFactorUserCode (userId: number, dobleFactorType: string): (Promise<UsuarioDobleAutenticacion>) {
    return new Promise<UsuarioDobleAutenticacion>(async (resolve, reject) => {
      const result = this.apolloClient.executeQuery(SET_DOBLE_FACTOR_USER_CODE, { userId: userId,  dobleFactorType: dobleFactorType})
      
      watch(result, (value: any) => {
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.usuarioDobleAutenticacionQuery.setDobleFactorUserCode)
        }
        catch(e) {
          reject()
        }
      });
    });
  }

  async confirmDobleFactorUser (userId: number): (Promise<UsuarioDobleAutenticacion>) {
    return new Promise<UsuarioDobleAutenticacion>(async (resolve, reject) => {
      const result = this.apolloClient.executeQuery(CONFIRM_DOBLE_FACTOR_USER, { userId: userId })
      
      watch(result, (value: any) => {
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.usuarioDobleAutenticacionQuery.confirmDobleFactorUser)
        }
        catch(e) {
          reject()
        }
      });
    });
  }
}

